function initializeSorting() {
	const sortButtons = document.querySelectorAll(".sort-button");
	const productGrid = document.getElementById("product-grid");
	const gridItems = Array.from(productGrid.children);

	// Store the original order of grid items
	const originalOrder = [...gridItems];

	// Helper to fix date format
	const fixDateFormat = (dateString) => {
		return dateString
			.replace(" ", "T") // Replace space between date and time with 'T'
			.replace(/(\+\d{2})(\d{2})$/, "$1:$2")
			.replace(" ", "");
	};

	// Function to sort and render grid items
	const sortAndRenderGrid = (sortTag) => {
		// Highlight the active sort button
		sortButtons.forEach((btn) => btn.classList.remove("active-sort-button"));
		const activeButton = Array.from(sortButtons).find(
			(btn) => btn.dataset.sort.toLowerCase() === sortTag
		);
		if (activeButton) activeButton.classList.add("active-sort-button");

		// Reset grid to original order if 'reset' or 'staff pick' button is clicked
		if (sortTag === "staff pick") {
			productGrid.innerHTML = "";
			originalOrder.forEach((item) => productGrid.appendChild(item));
			return;
		}

		// Sort grid items based on the selected filter
		const sortedItems = [...gridItems].sort((a, b) => {
			if (sortTag === "newest") {
				const dateA = new Date(fixDateFormat(a.dataset.created));
				const dateB = new Date(fixDateFormat(b.dataset.created));
				return dateB - dateA;
			} else {
				const tagsA = a.dataset.tags.toLowerCase().split(",");
				const tagsB = b.dataset.tags.toLowerCase().split(",");
				const hasTagA = tagsA.includes(sortTag);
				const hasTagB = tagsB.includes(sortTag);

				if (hasTagA && !hasTagB) return -1;
				if (!hasTagA && hasTagB) return 1;
				return 0;
			}
		});

		// Update the grid with the sorted items
		productGrid.innerHTML = "";
		sortedItems.forEach((item) => productGrid.appendChild(item));
	};

	// Add event listeners to sort buttons
	sortButtons.forEach((button) => {
		button.addEventListener("click", () => {
			const sortTag = button.dataset.sort.toLowerCase();

			// Update the URL parameters
			const url = new URL(window.location.href);
			url.searchParams.set("sort", sortTag);
			window.history.replaceState({}, "", url);

			sortAndRenderGrid(sortTag);
		});
	});

	// Get the initial sort parameter from the URL and render the grid
	const url = new URL(window.location.href);
	const initialSort = url.searchParams.get("sort");
	if (initialSort) {
		sortAndRenderGrid(initialSort.toLowerCase());
	} else {
		sortAndRenderGrid("staff pick"); // Default sort
	}
}

document.addEventListener("DOMContentLoaded", initializeSorting);

// // Get the button:
// let scrollTopButton = document.getElementById("backToTopButton");

// // When the user scrolls down 20px from the top of the document, show the button
// window.onscroll = function () {
// 	scrollFunction();
// };

// function scrollFunction() {
// 	if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
// 		scrollTopButton.style.display = "block";
// 	} else {
// 		scrollTopButton.style.display = "none";
// 	}
// }

// // When the user clicks on the button, scroll to the top of the document
// function topFunction() {
// 	document.body.scrollTop = 0; // For Safari
// 	document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
// }
